import React from 'react';

const Logo = props => {
  return (
    <img
      alt="Logo"
      src="/static/images/landingpage/sign-in-logo.png"
      {...props}
    />
  );
};

export default Logo;
